import fetchWithRetries from 'common/ui/lib/fetch';

export async function getAuth0ClientId(organization: string) {
  return fetchWithRetries({
    url: `/web/pub-v1/org/${organization}/auth0ClientId`,
  });
}
